import React, { useState } from "react";
import { Button, TextField, FormControlLabel, Switch } from "@material-ui/core";
import useStyles from "../../components/Common/styles";
import SaveIcon from "@material-ui/icons/Save";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Blade, BladeValidationDisplay } from "../../components/Common/Blade";
import { toastr } from "../../components/Common/toastr";
import useProtectApi from "../../hooks/useProtectApi";

const CaseCategoryCreate = () => {
	const classes = useStyles();
	const { register, handleSubmit, errors } = useForm();
	const history = useHistory();
	const dispatch = useDispatch();

	const caseCategoryCreateApi = useProtectApi("CaseCategory/create");

	const [createErrors, setCreateErrors] = useState();
	const [isBusy, setIsBusy] = useState(false);

	const onSubmit = async (data) => {
		var request = {
			name: data.name,
			isSpecialCase: data.isSpecialCase,
			isYoungWorker: data.isYoungWorker,
		};

		const createCaseCategory = () =>
			caseCategoryCreateApi.api().then((w) =>
				w
					.post(request)
					.badRequest((err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setCreateErrors(errDetail);
						throw new Error(errDetail);
					})
					.error(409, (err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setCreateErrors(errDetail);
						throw new Error(errDetail);
					})
					.json((json) => {
						var newPartner = {
							...request,
							id: json.id,
						};

						dispatch({
							type: "CREATE_CASE_CATEGORY",
							payload: newPartner,
						});

						return newPartner;
					})
					.then(() => toastr.success("Case Category created!"))
					.then(() => closeDrawer())
					.catch((error) => {
						console.log(error);
						toastr.error("Unable to create new Case Category.");
					})
					.finally(() => setIsBusy(false))
			);

		setIsBusy(true);
		createCaseCategory();
	};

	const closeDrawer = () => {
		history.push("/casecategories");
	};

	return (
		<Blade title="Create New Case Category">
			<div>
				<form onSubmit={handleSubmit(onSubmit)}>
					<section name="Name">
						<TextField
							label="Name *"
							fullWidth
							autoFocus
							name="name"
							error={!!(errors && errors.name)}
							style={{ marginBottom: 16 }}
							autoComplete="off"
							inputRef={register({
								required: {
									value: true,
									message: "Name is required",
								},
								maxLength: {
									value: 255,
									message: "Name is too long",
								},
							})}
							inputProps={{
								"aria-label": "Name",
							}}
							helperText={errors && errors.name && errors.name.message}
						/>
					</section>

					<section name="Special Case">
						<FormControlLabel
							labelPlacement="start"
							control={<Switch color="primary" name="isSpecialCase" inputRef={register({})} />}
							label="Is Special Case Status"
						/>
					</section>

					<section name="Young Worker">
						<FormControlLabel
							labelPlacement="start"
							control={<Switch color="primary" name="isYoungWorker" inputRef={register({})} />}
							label="Is Young Worker Status"
						/>
					</section>

					{!!createErrors && <BladeValidationDisplay validationErrors={createErrors} />}

					<div className={classes.drawerBladeToolbar}>
						<Button
							variant="contained"
							color="primary"
							size="medium"
							type="submit"
							className={classes.button}
							endIcon={<SaveIcon />}
							disabled={isBusy}>
							SAVE
						</Button>
					</div>
				</form>
			</div>
		</Blade>
	);
};
export default CaseCategoryCreate;
